import { contentRegistry } from './buildContentRegistry';
export const getDocumentById = (id) => contentRegistry.documentsById.get(id);
//# sourceMappingURL=getDocumentById.js.map